module.exports = __webpack_public_path__ + "img/sc.9d5a1ab4.svg";